import React, { useEffect, useState } from "react";
import MainCard from "../../components/ui-component/card/MainCard";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Backdrop,
  Box,
  Button,
  CardContent,
  Checkbox,
  Chip,
  CircularProgress,
  Collapse,
  Fab,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  styled,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { fDate } from "../../../utils/formatTime";

import DeleteIcon from "@mui/icons-material/Delete";
import FilterListIcon from "@mui/icons-material/FilterListTwoTone";
import PrintIcon from "@mui/icons-material/PrintTwoTone";
import FileCopyIcon from "@mui/icons-material/FileCopyTwoTone";
import SearchIcon from "@mui/icons-material/Search";
import AddIcon from "@mui/icons-material/AddTwoTone";

import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";

import PackagesFilter from "./PackagesFilter";
import { useNavigate } from "react-router-dom";
import { useGetTokenOrLogout } from "../../../utils/token";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import HeadingCard from "../../newComponent/NewCardsComp/HeadingCard";
import AddButton from "../../newComponent/NewButtonComp/AddButton";
import FilterButtonComponent from "../../newComponent/NewButtonComp/FilterButtonComponent";
import SearchTextFieldComp from "../../newComponent/newtextfieldComp/SearchTextFieldComp";
import StyledTableContainer from "../../newComponent/TableContainer";
import { DataGrid } from "@mui/x-data-grid";
import CustomNoRowsOverlay from "../../newComponent/TableCustomeComp/CustomNoRowsOverlay";
import TestPrepPackages from "./TestPrepPackages";
import ScolarPackagesList from "./ScolarPackagesList";
import CustomPopup from "../../../components/CustomPopup";

import AddTestPrepPackages from "./AddTestPrepPackages";
import AddScholarPackages from "./AddScholarPackages";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function PackagesList() {
  const getTokenOrLogout = useGetTokenOrLogout();
  const userRole = localStorage.getItem("userRole");
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const theme = useTheme();
  const [serviceList, setServiceList] = useState([]);
  const [packages, setPackages] = useState([]);

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filterCriteria, setFilterCriteria] = useState(null);
  const [originalData, setOriginalData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedChip, setSelectedChip] = useState(1);

  const handleChipClick = (criteria) => {
    setSelectedChip(criteria);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen(!open);
  };

  const [isTestPrepFormOpen, setTestPrepFormOpen] = useState(false);
  const [isScholarFormOpen, setIscholarFormOpen] =useState(false)

  const [searchData, setSearchData] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${API_ENDPOINT}service`);
        if (response.ok) {
          const data = await response.json();
          const sortedData = data.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          const filteredData = sortedData
            .filter((i) => i.service_name !== "Undefined")
            .reverse();
          setServiceList(filteredData);
        } else {
          throw new Error(`Request failed with status: ${response.status}`);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleOpenForm = () => {
    setTestPrepFormOpen(true);
  };

  const handleCloseForm = () => {
    setTestPrepFormOpen(false);
  };

  
  const handleOpenScholarForm = () => {
    setIscholarFormOpen(true);
  };

  const handleCloseScholarForm = () => {
    setIscholarFormOpen(false);
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4} lg={2}>
          <HeadingCard label="Packages List" />
        </Grid>

        <Grid item xs={12} md={12} sm={12} lg={12}>
          <Grid container>
            <Grid item xs={12} md={8} sm={12} lg={8}>
              <Grid container gap={2}>
                {serviceList.map((data) => (
                  <Button
                    size="small"
                    key={data?.id}
                    style={{
                      fontWeight: selectedChip === data?.id ? 600 : 500,
                      background: selectedChip === data?.id ? "#07b344" : "",
                      borderRadius: "10px",
                      color: selectedChip !== data?.id ? "#364152" : "white",
                      border:
                        selectedChip !== data?.id ? "0.5px solid #b2b2b4" : "",
                    }}
                    onClick={() => handleChipClick(data?.id)}
                  >
                    {data?.service_name}
                  </Button>
                ))}

                {/* <Button
                    size="small"
                    style={{
                      fontWeight:
                        selectedChip === "scholar" ? 600 : 500,
                      background:
                        selectedChip === "scholar" ? "#07b344" : "",
                      borderRadius: "10px",
                      color:
                        selectedChip !== "scholar"
                          ? "#364152"
                          : "white",
                      border:
                        selectedChip !== "scholar"
                          ? "0.5px solid #b2b2b4"
                          : "",
                    }}
                    onClick={() => handleChipClick("scholar")}
                  >
               Scholars Admission Program
                  </Button> */}
              </Grid>
            </Grid>

            <Grid
              item
              xs={12}
              md={4}
              sm={12}
              lg={4}
              display="flex"
              justifyContent="flex-end"
              gap={1}
            >
              {(userRole === "center_admin" || userRole === "developer") && (
                <>
                {
                selectedChip===1 && ( 
                <AddButton
                  onClick={() => handleOpenForm(null)}
                 label="Add TestPrep Package"
                />
                ) }
                {selectedChip===2 &&  (<AddButton
                onClick={() => handleOpenScholarForm(null)}
               label="Add Scholar Package"
              />
                )}
                </>
              )}

              <FilterButtonComponent
                onClick={handleToggle}
                showendIcon={true}
                open={open}
                text="Filter"
              >
                Filter
              </FilterButtonComponent>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          item
          xs={12}
          sm={9}
          md={9.5}
          lg={10}
          sx={{ textAlign: "right" }}
          container
          gap={1}
          justifyContent="end"
        >
          {/* product add & dialog */}
        </Grid>

        <Grid item xs={12}>
          {selectedChip === 1 && (
            <TestPrepPackages open={open} serviceId={selectedChip} />
          )}
          {selectedChip === 2 && (
            <ScolarPackagesList open={open} serviceId={selectedChip} />
          )}
        </Grid>
      </Grid>

{selectedChip===1 && (
      <CustomPopup
        open={isTestPrepFormOpen}
        onClose={handleCloseForm}
        component={
          <AddTestPrepPackages
            onClose={handleCloseForm}
            serviceId={selectedChip}
          />
        }
        title="Add Testprep Package"
        showDivider={true}
        maxWidth="md"
      />
    )}
      
      {selectedChip===2 && (
<CustomPopup
        open={isScholarFormOpen}
        onClose={handleCloseScholarForm}
        component={
          <AddScholarPackages
            onClose={handleCloseScholarForm}
            serviceId={selectedChip}
          />
        }
        title="Add Scholar Package"
        showDivider={true}
        maxWidth="sm"
      />
      )}
    </>
  );
}

export default PackagesList;
